<template>
  <ModalBase @close-modal="$store.dispatch('closeLimitedModal')">
    <div class="cnt">
      <p class="lead">
        <strong>
          会員限定コンテンツになります。<br />ご利用には会員登録またはログインが必要です。
        </strong>
      </p>
      <p>
        会員登録すると、「お気に入り登録」「資料請求」「見学申込み」など様々な機能が使えるようになります。また、会員限定のお役立ち情報や特集も満載！
      </p>

      <div class="limitedModalButton">
        <p class="btn">
          <Button
            :href="`/register/user_category?q=${$route.path}`"
            label="会員登録する"
            :handleClick="
              () => goTo(`/register/user_category?q=${$route.path}`)
            "
            secondary
          />
        </p>
        <p class="btn">
          <Button
            :href="`/login?q=${query}`"
            label="ログイン"
            :handleClick="() => goTo(`/login?q=${query}`)"
            primary
            border
          />
        </p>
      </div>
    </div>
  </ModalBase>
</template>

<script lang="ts">
import { computed } from '@vue/runtime-core'
import ModalBase from '@/components/genenral/ModalBase.vue'
import Button from '@/components/elements/Button.vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
  name: 'LimitedModal',

  components: {
    ModalBase,
    Button
  },

  setup(props: any) {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    const query = computed(() => {
      return store.state.limitedModalLoginQuery
        ? store.state.limitedModalLoginQuery
        : route.path
    })

    const goTo = (path: string) => {
      router.push(path)
      store.dispatch('closeLimitedModal')
    }

    return {
      goTo,
      query
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.cnt {
  padding-left: 20px;
  padding-right: 20px;

  @include mixins.media() {
    padding-left: 50px;
    padding-right: 50px;
  }
}

.lead {
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  color: var.$color-main;

  &::before {
    content: '';
    display: block;
    width: 75px;
    height: 75px;
    margin: 0 auto 10px;
    background: url('~@/assets/images/icon/user2.svg') no-repeat;
    background-size: 100% 100%;

    @include mixins.media() {
      margin-bottom: 20px;
    }
  }

  > strong {
    font-weight: inherit;
  }

  & + p {
    margin-top: 10px;

    @include mixins.media() {
      margin-top: 20px;
    }
  }
}

.limitedModalButton {
  margin-top: 30px;

  @include mixins.media() {
    display: flex;
    justify-content: center;

    .btn {
      width: 215px;
    }
  }

  .btn:last-child {
    margin-top: 20px;

    @include mixins.media() {
      margin-top: 0;
      margin-left: 16px;
    }
  }
}

::v-deep(.button) {
  max-width: none;
}
</style>
